import moment from 'moment';
import lodash from 'lodash';
const insuredFactorFun = {
  // 根据规则对象返回结果
  insuredSize: (conditionFun, insuredLength, certifyValueLength) => {
    return conditionFun(Number(insuredLength), Number(certifyValueLength));
  },
  insuredAge: (conditionFun, insuredAge, productAge) => {
    return conditionFun(Number(insuredAge), Number(productAge));
  }
};

const getAgeTodays = time => {
  const m1 = moment(moment().format('YYYY-MM-DD')); // 获取需要对比的时间

  const m2 = moment(moment(time).format('YYYY-MM-DD')); // 计算相差多少天 day可以是second minute

  const day = m1.diff(m2, 'day');
  return day;
};

const unitList = {
  // 根据单位不同，返回相同单位的数字
  day: age => {
    return age;
  },
  year: (age, condition) => {
    let years = moment().subtract(Number(age), 'y');

    if (condition === 'lessThanEquals') {
      years = moment().subtract(Number(age) + 1, 'y').add(1, 'd');
    }

    if (condition === 'greaterThan') {
      years = moment().subtract(Number(age) + 1, 'y').add(1, 'd');
    }

    const newAge = years.format('YYYY-MM-DD');
    const days = getAgeTodays(newAge); // console.log('years==>', age, condition, newAge,)

    return days;
  }
};
const conditionRuleFun = {
  // 根据判断条件进行值的对比
  greaterThan: (a, b) => {
    return a > b;
  },
  greaterThanEquals: (a, b) => {
    return a >= b;
  },
  equals: (a, b) => {
    return a === b;
  },
  lessThan: (a, b) => {
    return a < b;
  },
  lessThanEquals: (a, b) => {
    return a <= b;
  }
};
const flagCondition = {
  // 判断所有条件满足情况
  and: (flags = []) => {
    let flag = true;
    flags && flags.forEach(item => {
      flag = flag && item;
    });
    return flag;
  },
  or: (flags = []) => {
    let flag = true;
    flags && flags.forEach(item => {
      flag = flag || item;
    });
    return flag;
  }
};
const whetherInsuredMap = {
  // 判断是否开启投保本产品
  Y: true,
  N: false
};

const judgeResult = props => {
  // 根据单个规则返回比较的结果
  const {
    certifyName,
    certifyCode,
    certifyValue,
    valueUnit,
    birthday,
    insuredLength
  } = props;
  const productVarAge = valueUnit && unitList[valueUnit](certifyValue, certifyName);
  const insuredVarAge = getAgeTodays(birthday);
  const judgeConditionFun = certifyName && conditionRuleFun[certifyName];
  const result = insuredFactorFun[certifyCode](judgeConditionFun, insuredVarAge, productVarAge, insuredLength, certifyValue);
  return result;
}; // 过滤根据计划层规则过滤计划


export const filterPlan = (planList, insuredItem, insuredLength) => {
  const {
    birthday
  } = insuredItem;

  if (!(lodash.isArray(planList) && planList.length)) {
    return [];
  }

  return planList.filter(({
    planItem
  } = {}) => {
    const {
      planCollocationRule
    } = planItem || {};
    const {
      whetherInsured,
      conditionInfo = [],
      conditionRelation
    } = planCollocationRule || {};

    if (!(lodash.isArray(conditionInfo) && conditionInfo.length)) {
      return true;
    }

    const flags = conditionInfo.map(conditionItem => {
      const {
        certifyCode,
        certifyValue,
        valueUnit,
        relationType
      } = conditionItem;
      return judgeResult({
        certifyName: relationType,
        certifyCode,
        certifyValue,
        valueUnit,
        birthday,
        insuredLength
      });
    });
    const flagResult = flagCondition[conditionRelation](flags); // 是否投保本计划 whetherInsured

    return whetherInsuredMap[whetherInsured] ? flagResult : !flagResult;
  });
};